import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@heroui/react';
import { Code } from 'lucide-react';

interface CodeStepProps {
  content?: {
    code?: string;
  };
  title?: string;
}

const CodeStep: React.FC<CodeStepProps> = ({ content, title }) => {
  const code = content?.code || '';

  if (!code) {
    return <div className="text-center text-gray-500 dark:text-gray-400 py-8">No code available</div>;
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      console.error('Failed to copy code:', error);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Code className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">CODE</span>
        </div>
        <Button size="sm" variant="flat" startContent={<Download className="w-4 h-4" />} onPress={handleCopy}>
          Copy
        </Button>
      </div>
      <div className="bg-gray-900 dark:bg-gray-950 rounded-lg p-4 overflow-x-auto">
        <pre className="text-green-400 text-sm font-mono">
          <code>{code}</code>
        </pre>
      </div>
    </div>
  );
};

export default CodeStep;
